import PropTypes from "prop-types";
// @mui
import {
  Grid,
  Card,
  Paper,
  Typography,
  CardHeader,
  CardContent,
} from "@mui/material";

// ----------------------------------------------------------------------

export default function AnalyticsTrafficBySite() {
  return (
    <Card>
      <CardHeader title="Traffic by Site" />
      <CardContent>
        <Grid container spacing={2}>
          {[].map((site) => (
            <SiteItem key={site.name} {...site} />
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}

// ----------------------------------------------------------------------

SiteItem.propTypes = {
  site: PropTypes.shape({
    price: PropTypes.any,
    title: PropTypes.string,
    order: PropTypes.any,
    hiddenprice: PropTypes.bool,
  }),
};

export function formatAsINR(number) {
  if (number == null || isNaN(number)) {
    number = 0;
  }
  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  });
  return formatter.format(number);
}

export function SiteItem({ title, order, price, hiddenprice }) {
  const safeOrder = order ?? 0;
  const safePrice = isNaN(price) || price == null ? 0 : price;
  const safeTitle = title || "NA";

  return (
    <Paper
      variant="outlined"
      sx={{
        py: 2.5,
        textAlign: "center",
        boxShadow: (theme) => theme.customShadows?.z20 || 3,
      }}
    >
      <Typography variant="h4">{safeOrder}</Typography>

      {!hiddenprice && (
        <Typography variant="subtitle1">{formatAsINR(safePrice)}</Typography>
      )}

      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {safeTitle}
      </Typography>
    </Paper>
  );
}
